export default "__VITE_ASSET__Br2X0tow__"